import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "./index.css";

// Apply the saved/system theme before the first paint (no flash, no hidden content).
try {
  const saved = localStorage.getItem("adr-theme");
  const dark = saved ? saved === "dark" : window.matchMedia?.("(prefers-color-scheme: dark)").matches;
  document.documentElement.classList.toggle("dark", !!dark);
} catch {
  /* storage blocked: default light theme */
}

const container = document.getElementById("root");
if (!container) {
  document.body.insertAdjacentHTML("beforeend", "<p style='padding:24px'>Startup error: #root element missing.</p>");
} else {
  createRoot(container).render(
    <StrictMode>
      <ErrorBoundary scope="app">
        <App />
      </ErrorBoundary>
    </StrictMode>,
  );
}
